<template>
  <!--
    LESSON: The #campaign wrapper and [page] attribute come from the outer HBS template
    in beauty-box. In Vue, the root component IS the entry point, so we own this wrapper.
    The CSS selectors like `#campaign section#hero` and `#campaign [page='index'] .inner`
    depend on this structure being in the DOM.
  -->
  <div id="campaign">
    <div page="index">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
@import "~appSCSS";
</style>
